import { render, staticRenderFns } from "./BButtonSubmitButton.vue?vue&type=template&id=7c8bf7a2"
import script from "./BButtonSubmitButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BButtonSubmitButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports